<template>
    <div class="news">
        <b-modal 
            size="xl"
            title="Row Info" 
            v-model="showRow" 
            no-close-on-backdrop
            @ok="showRow=false"
            ok-variant="info"
            ok-only
        >
            <table border="0">
                <tr>
                    <td>Image</td>
                    <td><img width="512" :src="`/images/promo/${promo.promoimage}`"></td>
                </tr>
                <tr>
                    <td>Title</td>
                    <td>{{promo.title}}</td>
                </tr>
                <tr>
                    <td>Description</td>
                    <td>{{promo.description}}</td>
                </tr>
                <tr>
                    <td>From Date</td>
                    <td>{{dateFormatter({value:promo.fromdate})}}</td>
                </tr>
                <tr>
                    <td>To Date</td>
                    <td>{{dateFormatter({value:promo.todate})}}</td>
                </tr>
                <tr>
                    <td>Units</td>
                    <td>{{promo.machines ? promo.machines.replaceAll(',',' ') : ''}}</td>
                </tr>
                <tr>
                    <td>Filter</td>
                    <td>{{sqlFormatter({value:promo.sql})}}</td>
                </tr>
            </table>
        </b-modal>
        <b-container fluid>
            <b-row>
                <b-col>
                    <AgGridVue
                        style="
                            width: calc(100% - 20px);
                            height: calc(100vh - 180px);
                        "
                        class="ag-theme-alpine"
                        :columnDefs="columnDefsP"
                        :rowData="promos"
                        :defaultColDef="defaultColDef"
                        :suppressColumnVirtualisation="false"
                        @first-data-rendered="onFirstDataRenderedP"
                        @grid-ready="onGridReadyP"
                        @row-double-clicked="onRowDoubleClicked"
                    >
                    </AgGridVue>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
    name: "SiteAdmin",
	components: {
		AgGridVue,
	},
    data() {
        return {
            showRow: false,
            columnDefsP: [
                { headerName: "Image", field: "promoimage",cellRenderer: params => {
                        return `<img height="100%" src="/images/promo/${params.value}">`;
                    } },
                { headerName: "Title", field: "title", filter: 'agTextColumnFilter' },
                { headerName: "Description", field: "description", filter: 'agTextColumnFilter', width: 300, suppressSizeToFit: true, maxWidth: 300  },
                { headerName: "From Date", field: "fromdate", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,  },
                { headerName: "To Date", field: "todate", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,  },
                { headerName: "Units", field: "machines", filter: 'agTextColumnFilter',suppressSizeToFit: true, maxWidth: 300  },
                { headerName: "Filter", field: "sql", filter: 'agTextColumnFilter',valueFormatter: this.sqlFormatter,  },
            ],
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            gridApiP: null,
            columnApiP: null,
            promos: [],
            promo: {},
        };
    },
    computed: {
    },
    async mounted() {
        try {
			// console.log("this.$store.getters.client_code",this.$store.getters.client_code)
            let promos = await API.getPromos(this.$store.getters.client_code,true);
            this.promos = promos.map(d => ({
                id: d.id,
                promofilterid: d.promofilterid,
                promoimage: d.promoimage,
                title: d.title,
                machines: d.machines, // .join(','),
                description: d.description,
                template_id: d.template_id || 0,
                campaign_id: d.campaign_id || 0,
                fromdate: new Date(d.fromdate),
                todate: new Date(d.todate),
                active: d.active,
                sql: d.sql,
            }))
            // console.log("promos", this.promos);
        } catch (error) {
            console.error("SiteAdmin Mount", error); 
        }
        this.waiting = false;
    },
    methods: {
		async onRowDoubleClicked(params){
			console.log("rowDoubleClicked",params)
            this.promo = params.data
            this.showRow = true
		},
        dateFormatter(params) {
            // console.log("???", params);
            return params.value ? params.value.toDateString() : ''
        },
        sqlFormatter(params) {
            console.log("?0",params)
            if(!params.value)
                return null
            // prende la where e cerca di renderla più presentabile
            let sql = params.value
            let p1 = sql.indexOf("where")
            let p2 = sql.indexOf(")",p1)
            console.log("?1",sql,p1,p2)
            sql = sql.substring(p1+5,p2)
            let text = sql.split("and").map(t => t.trim()).filter(t => t!='1=1').join(" and ")
            console.log("?2",sql,text)
            return text
        },
        onGridReadyP(params) {
            // console.log("onGridReadyP", params);
            this.gridApiP = params.api;
            this.columnApiP = params.columnApi;
        },
        // eslint-disable-next-line no-unused-vars
		onFirstDataRenderedP(event) {
            this.columnApiP.autoSizeAllColumns();
        },
    },
};
</script>
<style>
.ag-left-aligned-cell {
    text-align: left;
}
</style>
<style scoped>
table tr td:first-child {
  font-weight: 700;
  vertical-align: top;
}
</style>
